module.exports = __webpack_public_path__ + "assets/img/KeyReport_003.55735bd0-ps.jpg";